import { useCallback, useState } from 'react';
import { rescale } from '../utils/rescale';

export const useLocalImages = (
  imagesLength = 1,
  quality = 1,
  onChange?: (img?) => void
) => {
  // images from local directory
  const [images, setImages] = useState<Array<{ name: string; src: string }>>(
    []
  );
  const [isReadingFile, setIsReadingFile] = useState(false);

  const onAdd = useCallback(
    (item) => {
      if (!item) return;
      setImages((prev) => {
        if (prev.length < imagesLength) {
          return [...prev, item];
        }
        prev.reverse().pop();
        return [...prev.filter((p) => p.name !== item.name), item];
      });
      onChange?.(item);
    },
    [imagesLength, onChange]
  );

  const onDelete = useCallback(
    (img) => {
      if (!img) return;
      setImages((prev) => prev.filter((i) => i.name !== img.name));
      onChange?.(img);
    },
    [onChange]
  );

  /** handle select/drop pictures in Dropzone */
  const onDrop = useCallback(
    (acceptedFile) => {
      acceptedFile.slice(0, imagesLength).forEach((file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onloadstart = () => setIsReadingFile(true);
        reader.onload = (e) => {
          const base64Str = e.target.result as string;
          const newItem = {
            name: file.name,
            src: base64Str
          };
          if (quality > 0 && quality < 1) {
            const img = new Image();
            img.src = base64Str;
            img.onload = () => {
              const canvas = document.createElement('canvas');
              const { width, height } = rescale(
                img.width,
                img.height,
                1280,
                1280
              );
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);

              const compressed = canvas.toDataURL('image/jpeg', quality);
              newItem.src = compressed;
            };
          }
          onAdd(newItem);
          setIsReadingFile(false);
        };
        reader.readAsDataURL(file);
      });
    },
    [onAdd, imagesLength, quality]
  );

  return {
    images,
    isReadingFile,
    onDrop,
    onDelete
  };
};
